import { useState, useEffect } from 'react';
export const useSessionStorage = (key, initialValue) => {
    const [storedValue, setStoredValue] = useState(initialValue);
    useEffect(() => {
        if (typeof window !== 'undefined') {
            try {
                const item = window.sessionStorage.getItem(key);
                if (item) {
                    setStoredValue(item);
                }
            }
            catch (error) {
                console.error(error);
            }
        }
    }, [key]);
    const setValue = (value) => {
        if (typeof window !== 'undefined') {
            try {
                setStoredValue(value);
                window.sessionStorage.setItem(key, String(value));
            }
            catch (error) {
                console.error(error);
            }
        }
    };
    return [storedValue, setValue];
};
export default useSessionStorage;
//# sourceMappingURL=useSessionStore.js.map